import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import * as fromRoutes from "../actions/types";
import Customer from "./customer-container";
import Customers from "./customer-list-container";
import Summary from "./summary-container";
import NotFound from "./not-found";
import { useRouter } from "utils";

const CustomersRoutes = ({ onGetCustomersList, onSearchClear }) => {
	useEffect(() => {
		onSearchClear();
		onGetCustomersList();
	}, [onGetCustomersList, onSearchClear]);

	return (
		<Switch>
			<Route
				exact
				path={fromRoutes.CUSTOMERS_ROUTE}
				component={Customers}
			/>
			<Route path={fromRoutes.CUSTOMER_TAB_ROUTE} component={Customer} />
		</Switch>
	);
};

CustomersRoutes.propTypes = {
	onGetCustomersList: PropTypes.func.isRequired,
	onSearchClear: PropTypes.func.isRequired,
};

/**
 * Customer detail is a single page (summary + embedded sections). Legacy URLs such as
 * /customers/:id/notes or /customers/:id/sites redirect to /customers/:id.
 */
export const ChildRoutes = ({ onAddSite, onAddPhotoNote }) => {
	const { match, location } = useRouter();
	const customerId = match && match.params && match.params.customerId;
	const base = `${fromRoutes.CUSTOMERS_PATH}/${customerId}`;
	const pathname = (location && location.pathname) || "";
	const normalized = pathname.replace(/\/+$/, "");
	const normalizedBase = base.replace(/\/+$/, "");
	if (
		customerId &&
		normalized !== normalizedBase &&
		normalized.startsWith(`${normalizedBase}/`)
	) {
		return <Redirect to={base} />;
	}
	return <Summary onAddSite={onAddSite} onAddPhotoNote={onAddPhotoNote} />;
};

ChildRoutes.propTypes = {
	onAddSite: PropTypes.func,
	onAddPhotoNote: PropTypes.func,
};

export default CustomersRoutes;
